<template>
  <div style="position: relative">
    <add-live-dialog
      :isOpen.sync="dialog"
      :liveId.sync="inputLiveId"
      :closeDialog="closeLiveDialog"
      :idcourse.sync="courseId"
    ></add-live-dialog>
    <v-btn
          elevation="0"
          outlined
          class="mb-0 body-1 text-primary text-capitalize"
          @click="openLiveDialog(inputLiveId)"
          style="position: absolute; top: -2px; right: 0;"
        >
          <v-icon class="mr-1">mdi-square-edit-outline</v-icon>
          <p class="mb-0">
            {{ $vuetify.lang.t('$vuetify.courseManagement.courseList.edit') }}
          </p>
      </v-btn>
    <div class="mb-6" >
        <div class="font-weight-bold title">Event name</div>
        <div class="description">{{title}}</div>
    </div>
    
    <div class="mb-6">
      <div class="font-weight-bold title">Instructor</div>
      <div class="chat-avatar">
        <v-avatar :size="50" :justify="center">
          <img
            :src="displayImage"
          />
        </v-avatar>
      </div>
      <div class="chat-message">
        <!-- <div class="chat-name">{{chat.displayName}}</div> -->
        <div>{{displayName}}</div>
      </div>
    </div>
    <div class="mb-6">
      <div class="font-weight-bold title">Date time</div>
      <div class="description">{{ startTime | moment("Do MMMM YYYY hh:mm") }} - {{ endTime | moment("Do MMMM YYYY hh:mm") }}</div>
    </div>
    <!-- <div class="mb-6">
      <div class="font-weight-bold title">URL Server</div>
      <v-row>
        <v-col :cols="8" :lg="10" :md="10" :sm="8">
          <div class="box-disable">
            {{urlServer}}
          </div>
        </v-col>
        <v-col :cols="4" :lg="2" :md="2" :sm="4">
          <div>
            <v-btn
              class="d-flex align-center white-text-btn btnCopy"
              color="#50ADDE"
              elevation="0"
              @click="copyToClipBoard(urlServer)"
            >Copy</v-btn>
          </div>
        </v-col>
      </v-row>
    </div> -->
    <!-- <div class="mb-6">
      <div class="font-weight-bold title">Stream Key</div>
      <v-row>
        <v-col :cols="8" :lg="10" :md="10" :sm="8">
          <div class="box-disable">
            {{streamKey}}
          </div>
        </v-col>
        <v-col :cols="4" :lg="2" :md="2" :sm="4">
          <v-btn
            class="d-flex align-center white-text-btn btnCopy"
            elevation="0"
            color="#50ADDE"
            @click="copyToClipBoard(streamKey)"
          >Copy</v-btn>
        </v-col>
      </v-row>
    </div> -->
  </div>
</template>

<script>
import addLiveDialog from '@/components/live/dialog/insertLiveDialog.vue';
export default {
  components: {
    addLiveDialog,
  },
  data() {
    return {
      liveId: '',
      dialog: false,
      params: {},
    }
  },
  props: {
    title: {
      type: String
    },
    displayName: {
      type: String
    },
    displayImage: {
      type: String
    },
    startTime: {
      type: Number
    },
    endTime: {
      type: Number
    },
    urlServer: {
      type: String
    },
    streamKey: {
      type: String
    },
    courseId: {
      type: String
    },
    inputLiveId: {
      type: String
    },
    refreshStream: {
      type: Function
    }
  },
  async mounted() {
    this.initialize();
  },
  methods: {
    copyToClipBoard(text) {
      navigator.clipboard.writeText(text);
    },
    openLiveDialog(id) {
      this.liveId = id;
      this.dialog = true;
    },
    closeLiveDialog() {
      console.log('closeLiveDialog')
      this.dialog = false;
      this.liveId = '';
      this.refreshStream();
    },
    initialize() {
      this.params = {
        id: this.$route.query.id,
      };
      // this.canwatch = 0;
      // this.searchdata = null;
      // this.getLiveAll();
    },
  }
};
</script>
<style scoped>
.description {
  font-size: 16px;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.title {
  font-size: 16px !important;
}
.btnCopy {
  border-radius: 0px !important;
}
</style>